import { FC } from 'react';

import Button from 'wa-storybook/components/general/button/button';
import styles from './intro-interests.module.scss';

import interestsImg from '../../assets/interests-il.svg';

type Props = {
  onSkip: () => void;
  onSetInterests: () => void;
};

const IntroInterests: FC<Props> = ({ onSkip, onSetInterests }: Props) => {
  return (
    <section className={styles['container']}>
      <div className={styles[`img-container`]}>
        <img src={interestsImg} alt='' />
      </div>

      <h1 className={styles.title}>
        {polyglot.t('home.interests.intro_screen.personalise')}
      </h1>

      <p className={styles.subtitle}>
        {polyglot.t('home.interests.intro_screen.description_2')}
      </p>

      <p className={styles.subtitle}>
        {polyglot.t('home.interests.intro_screen.description_3')}
      </p>

      <div className={styles[`button-container`]}>
        <Button
          text={polyglot.t('home.interests.intro_screen.skip')}
          theme='text--on-surface'
          onClick={onSkip}
        />

        <Button
          text={polyglot.t('home.interests.intro_screen.set_interests_cta')}
          onClick={onSetInterests}
        />
      </div>

      <p className={styles.info}>
        {polyglot.t('home.interests.intro_screen.info')}
      </p>
    </section>
  );
};

export default IntroInterests;
